<template>
  <div class="SX">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoRisk">企业资质</span>
        <span @click="GoSiXiang">党纪政务处分></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
      <div class="zhengwen">
        <h1>{{ msg.title }}</h1>
        <div class="first">
          <span class="third">{{ msg.source }}</span>
          <span class="si">|</span>
          <span>{{ msg.publishTime }}</span>
        </div>
        <div class="xh"></div>
        <div class="second ql-container ql-snow">
          <p class="ql-editor" v-html="msg.context"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      msg: [],
    };
  },
  created() {
    let id = this.$route.query.id;
    this.Api.getDj1({ id: id }).then((res) => {
      this.msg = res.data;
    });
  },
  methods: {
    GoRisk() {
      this.$router.push("/Investigate");
    },
    GoSiXiang() {
      this.$router.push("/Investigate/DangJi");
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}

h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}

.si {
  margin: 0 16px;
}
hr {
  display: block;
  color: #e8e8e8;
  height: 1px;
}
/deep/img {
  object-fit: cover;
  max-width: 1000px;
}
</style>
